document.documentElement.classList.remove('no-js');

document.addEventListener('change', function (event) {
  if (!event.target.matches('.variant-option-input')) return;
  const form = event.target.closest('.product-form');
  const variantSelect = form && form.querySelector('[data-variant-select]');
  const variantsScript = form && form.querySelector('[data-product-variants]');
  if (!form || !variantSelect || !variantsScript) return;

  const selectedOptions = Array.from(form.querySelectorAll('.variant-option-input:checked'))
    .sort(function (a, b) { return Number(a.dataset.optionIndex) - Number(b.dataset.optionIndex); })
    .map(function (input) { return input.value; });
  const variants = JSON.parse(variantsScript.textContent);
  const variant = variants.find(function (item) {
    return item.options.every(function (value, index) { return value === selectedOptions[index]; });
  });
  if (!variant) return;

  variantSelect.value = String(variant.id);
  const selectedVariantOption = variantSelect.options[variantSelect.selectedIndex];
  const available = selectedVariantOption.dataset.available === 'true';
  const button = form.querySelector('.product-submit');
  const details = form.closest('.product-details');
  const price = details && details.querySelector('.product-price');
  if (button) {
    button.disabled = !available;
    button.textContent = available ? 'Add to bag' : 'Sold out';
  }
  if (price && selectedVariantOption.dataset.price) price.textContent = selectedVariantOption.dataset.price;
  window.history.replaceState({}, '', window.location.pathname + '?variant=' + variant.id);
});

document.addEventListener('click', function (event) {
  const thumbnail = event.target.closest('[data-product-thumbnail]');
  if (thumbnail) {
    const gallery = thumbnail.closest('.product-gallery');
    const targetImage = document.getElementById(thumbnail.dataset.targetImage || '');
    if (!gallery || !targetImage || !gallery.contains(targetImage)) return;
    gallery.querySelectorAll('[data-product-gallery-image]').forEach(function (image) {
      image.hidden = image !== targetImage;
    });
    gallery.querySelectorAll('[data-product-thumbnail]').forEach(function (button) {
      const isActive = button === thumbnail;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
    return;
  }
  const filterButton = event.target.closest('[data-product-filter]');
  if (filterButton) {
    const section = filterButton.closest('.shop-section');
    if (!section) return;
    const selectedCategory = filterButton.dataset.productFilter;
    section.querySelectorAll('[data-product-filter]').forEach(function (button) {
      const isActive = button === filterButton;
      button.classList.toggle('active', isActive);
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
    section.querySelectorAll('[data-product-category]').forEach(function (card) {
      const categories = card.dataset.productCategory.split(' ');
      card.hidden = selectedCategory === 'all'
        ? categories.includes('staff')
        : !categories.includes(selectedCategory);
    });
    return;
  }

  const quickAdd = event.target.closest('[data-demo-product]');
  if (!quickAdd) return;
  const scrollTarget = quickAdd.dataset.scrollTarget;
  if (scrollTarget) {
    document.getElementById(scrollTarget)?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    return;
  }

  const bagCount = document.querySelector('[data-bag-count]');
  if (bagCount) bagCount.textContent = String(Number(bagCount.textContent || 0) + 1);
  const toast = document.querySelector('[data-add-toast]');
  const toastText = document.querySelector('[data-add-toast-text]');
  if (!toast || !toastText) return;
  toastText.textContent = quickAdd.dataset.demoProduct + ' added to your bag';
  toast.hidden = false;
  window.clearTimeout(window.arnoldToastTimer);
  window.arnoldToastTimer = window.setTimeout(function () { toast.hidden = true; }, 2600);
});